import { render, staticRenderFns } from "./ExportButton.vue?vue&type=template&id=15713bf2&scoped=true&"
import script from "./ExportButton.vue?vue&type=script&lang=js&"
export * from "./ExportButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15713bf2",
  null
  
)

component.options.__file = "ExportButton.vue"
export default component.exports